import { render, staticRenderFns } from "./StudentProfile.vue?vue&type=template&id=18f7f66f&scoped=true&"
import script from "./StudentProfile.vue?vue&type=script&lang=js&"
export * from "./StudentProfile.vue?vue&type=script&lang=js&"
import style0 from "./StudentProfile.vue?vue&type=style&index=0&id=18f7f66f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f7f66f",
  null
  
)

export default component.exports